module.exports = __webpack_public_path__ + "img/locked-lesson-icon.cf40f7eb.svg";